module.exports = __webpack_public_path__ + "static/media/adventures.1f9046a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityBadge/icons/adventures.svg
// module id = 290
// module chunks = 0